import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';

export default {
  components: {
  },
  props: ['projectInfo', 'type', 'assetsmassifs'],
  data() {
    const validateCertificateNo = (rule, value, callback) => {
      if (value && value.length < 18) {
        callback(new Error('请输入正确的统一社会信用代码或身份证号'));
      } else {
        callback();
      }
    };
    // 总金额校验
    const sumPriceValidate = (rule, value, callback) => {
      if(value === '' || value === null){
        callback(new Error('请填写以上地块出租期限内的总金额'));
      } else if(Number(value) < 1 || Number(value) > 9999999999) {
        callback(new Error('请输入1-9999999999以内的数字'));
      } else {
        callback();
      }
    };
    return {
      typeArr: [],
      massifs: [
        {
          massifName: '',
          area: null,
          price: null,
          certificateNo: '',
          originalContractor: '', // 原承包人
          address: '', // 坐落位置
          serialNumber: '', // 房产证编号
          bidStructure: '', // 标的结构
          originalPurpose: '', // 建设用途
          attachmentRemark: ''
        }
      ],
      totalForm: {
        sumArea: null,
        everyYearSumPrice: null
      },
      rules: {
        massifName: [
          { required: true, message: '请输入建筑名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入建筑物坐落位置', trigger: 'blur' }
        ],
        // serialNumber: [
        //   { required: true, message: '请输入房产证编号', trigger: 'blur' }
        // ],
        bidStructure: [
          { required: true, message: '请输入标的结构', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入每年（期）租金', trigger: 'blur' }
        ],
        attachmentRemark: [
          { required: true, message: '请输入装修及附属设施情况', trigger: 'blur' }
        ],
        originalPurpose: [
          { required: true, message: '请输入建设用途', trigger: 'blur' }
        ],
        certificateNo: [
          { required: false, validator: validateCertificateNo, trigger: 'blur' }
        ]
      },
      totalFormRules: {
        everyYearSumPrice: [
          { required: true, validator: sumPriceValidate, trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    projectInfo: {
      handler: function() {
        const assetsInfo = this.projectInfo && this.projectInfo.assetsInfo && JSON.parse(this.projectInfo.assetsInfo);
        const arr = [];
        if(assetsInfo) {
          assetsInfo.forEach(item => {
            // const obj = JSON.parse(item);
            const obj = typeof item === 'string' ? JSON.parse(item) : item;
            Object.keys(obj).forEach((key) => {
              obj[key] = String(obj[key]);
            });
            arr.push(obj);
          });
        }
        if (arr.length) {
          this.massifs = arr;
        }
        Object.keys(this.totalForm).forEach((key) => {
          if(this.projectInfo[key] === undefined) return;
          this.totalForm[key] = this.projectInfo && String(this.projectInfo[key]);
        });
        this.$emit('landTotalForm', { sumPrice: this.totalForm.everyYearSumPrice, count: this.massifs.length });
      },
      immediate: true
    },
    assetsmassifs: {
      handler: function () {
        if (this.assetsmassifs.length > 0) {
          const arr = [];
          this.assetsmassifs.forEach(item => {
            arr.push({
              massifName: item.assetName,
              area: item.assetArea,
              price: null,
              certificateNo: '',
              originalContractor: '', // 原承包人
              address: '', // 坐落位置
              serialNumber: '', // 房产证编号
              bidStructure: '', // 标的结构
              originalPurpose: '', // 建设用途
              attachmentRemark: '',
              assetId: item.assetId
            });
          });
          if (arr.length) {
            this.massifs = arr;
            let sumArea = 0;
            this.massifs.forEach(item => {
              sumArea += Number(item.area);
            });
            this.totalForm.sumArea = sumArea.toFixed(2);
          }
        }
      },
      immediate: true // 初始化执行
    }
  },
  created () {
    Service.getSelectList('MASSIF_TYPE').then(res => {
      if (res && res.code === '0') {
        this.typeArr = res.data;
      }
    });
  },
  methods: {
    areaVali(rule, value, callback){
      if(value === '' || value === null){
        callback(new Error('请输入建筑面积'));
      } else if(value < 0 || value > 9999999.99){
        callback(new Error('请输入0-10000000以内的数字'));
      } else {
        callback();
      }
    },
    clear(){
      if( this.projectInfo.projectType === 6) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          price: null,
          certificateNo: '',
          originalContractor: '', // 原承包人
          address: '', // 坐落位置
          serialNumber: '', // 房产证编号
          bidStructure: '', // 标的结构
          originalPurpose: '', // 建设用途
          attachmentRemark: ''
        }
      ];
      this.totalForm = {
        sumArea: null,
        everyYearSumPrice: null
      };
      // 清空红色必填标示
      if(this.$refs['houseForm']) {
        this.$refs['houseForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        price: null,
        certificateNo: '',
        originalContractor: '', // 原承包人
        address: '', // 坐落位置
        serialNumber: '', // 房产证编号
        bidStructure: '', // 标的结构
        originalPurpose: '', // 建设用途
        attachmentRemark: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);

      let sumPrice = null;
      this.massifs.forEach(item => {
        sumPrice += Number(item.price);
      });
      this.totalForm.everyYearSumPrice = sumPrice.toFixed(2);
      this.$emit('landTotalForm', {sumPrice: this.totalForm.everyYearSumPrice, count: this.massifs.length});
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    },
    changePrice (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].price)) {
        return;
      }
      this.massifs[index].price = this.massifs[index].price && Number(this.massifs[index].price).toFixed(2);
      let num = null;
      this.massifs.forEach(item => {
        num += Number(item.price);
      });
      this.totalForm.everyYearSumPrice = num.toFixed(2);
      this.$emit('landTotalForm', {sumPrice: this.totalForm.everyYearSumPrice, count: this.massifs.length});
    },

    // 总金额改变
    changeSumPrice () {
      this.$emit('landTotalForm', {sumPrice: this.totalForm.everyYearSumPrice, count: this.massifs.length});
    },
    test() {
      return new Promise((resolve, reject) => {
        let num = 0;
        this.massifs.forEach((form, index) => {
          form.price = 0;
          this.$refs[`HouseForm${index}`][0].validate((valid) => {
            if (valid) {
              num ++;
            } else {
              reject();
            }
          });
        });
        if (num === this.massifs.length) {
          // 校验总金额
          this.$refs['totalForm'].validate((valid) => {
            if (valid) {
              console.log(this.totalForm, '==========tototalForm');
              resolve({
                massifs: JSON.parse(JSON.stringify(this.massifs)),
                ...this.totalForm
              });
            } else {
              reject();
            }
          });
        } else {
          reject();
        }
        // if (num === this.massifs.length) {
        //   resolve({
        //     massifs: JSON.parse(JSON.stringify(this.massifs)),
        //     ...this.totalForm
        //   });
        // } else {
        //   reject();
        // }
      });
    }
  }
};
